import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { swUpdateAvailable } from './swUpdate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Offline app shell (production builds only). A new deploy lands as a
// *waiting* worker → swUpdateAvailable() → App shows the update toast.
serviceWorkerRegistration.register({ onUpdate: swUpdateAvailable });
